import UpdateQuery from './component'

export default {
  install:  (Vue) => {
    let iUpdateQuery = Vue.extend(UpdateQuery)
    Vue.prototype.$createQuery = {
      show: (data) => {
        let instance = new iUpdateQuery ({
          el: document.createElement('div'),
        })
        document.body.appendChild(instance.$el)
        instance.show(data)
      }
    }
  }
}
